module.exports = __webpack_public_path__ + "media/images/flags/1x1/wlf-4757a4d8788ee4858167d994b83c4ed9.svg";